import React from "react";
import { useSelector } from "react-redux";
import ForgotPassword from "./forgetPassword";
import Userlogin from "./userlogin";

function Loginpage() {
  const forgetPassword = useSelector((state) => state.Login.isForgetPassword);

  return <div>{forgetPassword ? <ForgotPassword /> : <Userlogin />}</div>;
}

export default Loginpage;
